import _ from 'lodash';
import { makeAutoObservable, observable } from 'mobx';
import { ReactNode } from 'react';
import GlobalNotification from '../../../component/common/snackbar';
import { AuthGroup, Staff } from '../../../models';
import apiManage from '../../../request';
import { editAccountMobx } from '../account-manage/edit-account';
import { groupUnitData } from '../group-unit';
import i18n from 'i18next'
export enum PageState {
    /**
     * 员工账号编辑
     */
    AccountEdit,
    /**
     * 权限组
     */
    AuthGroupSetting,
    /**
     * 新增员工
     */
    AccountAdd
}

const RightOrder = [
    [
        'auth_cwa_0',
        'auth_cwa_1',
        'auth_cwa_2',
        'auth_cwa_3',
        'auth_cwa_4',
        'auth_cwa_5',
        'auth_cwa_6',
        'auth_cwa_7',
        'auth_cwa_8',
        'auth_cwa_9',
        'auth_cwa_10',
        'auth_cwa_11',
        'auth_cwa_12',
        'auth_cwa_13',
    ],
    [
        'auth_rwa_0',
        'auth_rwa_1',
        'auth_rwa_2',
        'auth_rwa_3',
        // 'auth_rwa_4',
    ],
    // shell 权限字段（与 Staff / 权限组 PATCH 字段一致；含菜单商店上传 auth_shell_2）
    ['auth_shell_1', 'auth_shell_2'],
]

export class AuthGroupData {
    viewAuthGroups = observable<AuthGroup>([]);

    sourceAuthGroups = observable<AuthGroup>([]);

    dialog: any = { open: false, title: '' }

    pageState: PageState = PageState.AuthGroupSetting;

    async setPageState(enterAccountEditPage?: 'ADD' | 'EDIT' | 'AU_SET' | string, accountInfo?: Staff) {
        this.reset();
        if (enterAccountEditPage === 'EDIT') {
            this.pageState = PageState.AccountEdit
        }
        else if (enterAccountEditPage === 'AU_SET') {
            this.pageState = PageState.AuthGroupSetting;
        } else {
            this.pageState = PageState.AccountAdd;
        }

        switch (this.pageState) {
            case PageState.AuthGroupSetting:
                this.getAuthGroups(groupUnitData.belongedGroup);
                break;
            case PageState.AccountEdit:
                await this.getAuthGroups(groupUnitData.belongedGroup);
                this.enterAccountEdit(accountInfo!);
                break;
            case PageState.AccountAdd:
                await this.getAuthGroups(groupUnitData.belongedGroup);
                this.enterAccountEdit(accountInfo!);
                break;
        }
    }

    reset() {
        this.dialog = { open: false, title: '' };
        this.viewAuthGroups.clear();
        this.sourceAuthGroups.clear();
        this.operationList.clear();
        this.route = 0;
        this.hadModified = false;
        this.isLoading = false
    }

    setDialog(value: any) {
        this.dialog = value
    }

    checkCWARWA(i: string) {
        return i.includes('rwa') || i.includes('cwa') || i.includes('shell')
    }
    route: number = 0;
    updateRoute(v: number) {
        switch (this.pageState) {
            case PageState.AccountEdit:
                for (const i in this.viewAuthGroups[v]) {
                    if (!this.checkCWARWA(i)) continue;
                    const now = (this.viewAuthGroups[v] as any)[i];
                    const old = (this.sourceAuthGroups[-1] as any)[i];
                    this.handleOperationCompare(i, Number(now), Number(old));
                }
                this.checkModify()
                this.route = v;
                if (this.sourceAuthGroups[-1]._id === this.viewAuthGroups[v]._id) {
                    this.hadModified = false
                } else {
                    this.hadModified = true
                }
                break;
            case PageState.AccountAdd:
                for (const i in this.viewAuthGroups[v]) {
                    if (!this.checkCWARWA(i)) continue;
                    const now = (this.viewAuthGroups[v] as any)[i];
                    const old = (this.sourceAuthGroups[-1] as any)[i];
                    this.handleOperationCompare(i, Number(now), Number(old));
                }
                this.checkModify()
                this.route = v;
                if (this.sourceAuthGroups[-1]._id === this.viewAuthGroups[v]._id) {
                    this.hadModified = false
                } else {
                    this.hadModified = true
                }
                break;

            case PageState.AuthGroupSetting:
                if (this.checkModify()) {
                    this.setDialog({
                        open: true,
                        title: i18n.t('general_text_tips'), message: i18n.t('auth_group_whether_save'),
                        option: [
                            [i18n.t('account_manager_yes'), async () => {
                                await this.confirmSave(v)
                            }],
                            [i18n.t('general_text_no'), () => {
                                this.cancelSave(v)
                            }]
                        ]
                    });
                } else {
                    this.route = v;
                }
                break
        }
    }

    async confirmSave(nextRoute?: number) {
        await this.save();
        switch (this.pageState) {
            case PageState.AccountEdit:
                this.resetOP()
                this.enterAccountEdit(this.sourceAuthGroups[-1]);

                break;
            case PageState.AccountAdd:
                this.resetOP()
                this.enterAccountEdit(this.sourceAuthGroups[-1]);
                break;
            case PageState.AuthGroupSetting:
                if (nextRoute === undefined) nextRoute = this.route;
                this.resetOP()
                this.updateRoute(nextRoute);
                this.setDialog({ open: false });
                break
        }

    }

    enterAccountEdit(accountInfo: Staff | null) {
        if (accountInfo) {
            if (accountInfo.auth_group_id) {
                const route = this.sourceAuthGroups.findIndex(
                    e => e._id === accountInfo.auth_group_id
                );
                if (route !== -1) this.route = route;
                this.viewAuthGroups[-1] = accountInfo;
                this.sourceAuthGroups[-1] = _.cloneDeep(accountInfo);
            } else {
                this.route = -1;
                // set permission
                this.viewAuthGroups[-1] = accountInfo;
                this.sourceAuthGroups[-1] = _.cloneDeep(accountInfo);
            }
        }
    }

    async openEditNameDialog(content: ReactNode, index: number) {
        this.route = index;
        this.setDialog({
            open: true,
            content,
            title: i18n.t('auth_group_rename'),
            option: [
                [i18n.t('general_text_save'), async () => await this.confirmEditName()],
                [i18n.t('dish_book_page_cancel'), () => this.cancelEditName()]
            ]
        })
    }

    editingName: string = ''
    updateEditingName(name: string) {
        this.editingName = name;
    }
    async confirmEditName() {
        await this.save();
        this.setDialog({ open: false })
        this.updateEditingName('')
    }
    cancelEditName() {
        this.updateEditingName('')
        this.setDialog({ open: false })
    }

    cancelSave(nextRoute?: number) {
        switch (this.pageState) {
            case PageState.AccountEdit:
                this.resetOP()
                this.enterAccountEdit(this.sourceAuthGroups[-1]);
                break;
            case PageState.AccountAdd:
                this.resetOP()
                this.enterAccountEdit(this.sourceAuthGroups[-1]);
                break;
            case PageState.AuthGroupSetting:
                if (nextRoute === undefined || nextRoute === -1) nextRoute = this.route;
                this.viewAuthGroups = _.cloneDeep(this.sourceAuthGroups);
                if (this.sourceAuthGroups[-1] !== undefined) {
                    this.viewAuthGroups[-1] = _.cloneDeep(this.sourceAuthGroups[-1])
                }
                this.resetOP()
                this.updateRoute(nextRoute);
                this.setDialog({ open: false });
                break
        }
        return;
    }

    resetOP() {
        this.operationList.clear();
        this.checkModify();
    }

    constructor() {
        makeAutoObservable(this);
    }

    getGroupUnit(groupIndex: number) {
        return this.viewAuthGroups[groupIndex];
    }

    // cwa rwa shell 权限点
    getUnitList(g: 'cwa' | 'rwa' | 'shell') {
        if (!this.viewAuthGroups[this.route]) return [];
        if (g === 'cwa')
            return RightOrder[0]
        else if (g === 'rwa') {
            return RightOrder[1]
        } else {
            return RightOrder[2]
        }
    }

    // 筛查指定餐馆的权限组（总结出有哪些账号应用了此权限组，并总结出数量）
    async getAuthGroups(belongedGroup: string): Promise<void> {
        try {
            if (!belongedGroup) {
                // Notification.error(`${i18n.t('当前账号暂未关联餐厅')}`);
                return
            }

            this.operationList.clear();
            const params = {
                string_id: belongedGroup,
                //  $ 这个设置为大，拿到全部数据
                pagination_per_page: 666,
                pagination_page: 1,
            }
            const data = await apiManage.get_auth_group(params);

            this.updateAuthGroups(data.dbResults || [])
        } catch (error) {
            // Notification.error(`${i18n.t('获取权限组失败')}`)
        }
    }

    updateAuthGroups(newArr: AuthGroup[]) {
        this.sourceAuthGroups.replace(_.cloneDeep(newArr));
        this.viewAuthGroups.replace(_.cloneDeep(newArr))
    }

    handleChange(v: string, keyName: string) {

        const old = this.sourceAuthGroups[this.route][keyName as AuthGroupKey] + '';

        if (old !== v) {
            this.operationList.set(keyName, { old, now: v })
        } else {
            this.operationList.delete(keyName);
        }

        this.changeViewGroup(keyName, v);

        this.checkModify();

    }

    handleOperationCompare(i: string, now: number, old: number) {
        if (now !== old) {
            this.operationList.set(i, { now, old })
        } else {
            this.operationList.delete(i);
        }
    }

    @observable operationList = new Map();

    hadModified: boolean = false

    checkModify() {
        return this.hadModified = this.operationList.size !== 0
    }

    changeViewGroup(k: string, v: string) {
        const v2Num = Number(v);
        switch (this.pageState) {
            case PageState.AccountEdit:
                if (this.route === -1) {
                    (this.viewAuthGroups[-1] as any)[k] = v2Num;
                    this.viewAuthGroups.replace(_.cloneDeep(this.viewAuthGroups));
                } else {
                    this.copyFromSelectGroup();
                    this.route = -1;
                    (this.viewAuthGroups[-1] as any)[k] = v2Num;
                }
                break;
            case PageState.AccountAdd:
                if (this.route === -1) {
                    (this.viewAuthGroups[-1] as any)[k] = v2Num;
                    this.viewAuthGroups.replace(_.cloneDeep(this.viewAuthGroups));
                } else {
                    this.copyFromSelectGroup();
                    this.route = -1;
                    (this.viewAuthGroups[-1] as any)[k] = v2Num;
                }
                break;
            case PageState.AuthGroupSetting:
                this.viewAuthGroups.map((e, i) => i === this.route && ((e as any)[k] = v2Num))
                break;
        }
    }

    copyFromSelectGroup() {
        for (const i in this.viewAuthGroups[this.route]) {
            if (!this.checkCWARWA(i)) continue;
            const now = (this.viewAuthGroups[this.route] as any)[i];
            const old = (this.viewAuthGroups as any)[-1][i];
            if (now !== old) {
                this.operationList.set(i, { old, now })
            }
        }
        this.viewAuthGroups[-1] = _.cloneDeep(this.viewAuthGroups[this.route])
    }

    async save(_id?: string) {
        const cwaKey: string[] = this.getUnitList('cwa');
        const rwaKey: string[] = this.getUnitList('rwa');
        // shell 权限key
        const shellKey: string[] = this.getUnitList('shell');
        const cwaNow = cwaKey.reduce((pre, now) => {
            return {
                ...pre,
                [now]: this.viewAuthGroups[this.route][now as keyof AuthGroup]
            }
        }, {})
        const rwaNow = rwaKey.reduce((pre, now) => {
            return {
                ...pre,
                [now]: this.viewAuthGroups[this.route][now as keyof AuthGroup]
            }
        }, {});
        const shellNow = shellKey.reduce((pre, now) => {
            return {
                ...pre,
                [now]: this.viewAuthGroups[this.route][now as keyof AuthGroup]
            }
        }, {});

        if (cwaKey.length === 0 || rwaKey.length === 0 || shellKey.length === 0) {
            return
        }

        switch (this.pageState) {
            case PageState.AccountEdit:
                if (this.route !== -1) {
                    // 选用auth组的配置
                    const params = {
                        staff_id: editAccountMobx.sourceStaffBaseInfo?._id ?? _id ?? '',
                        auth_group_id: this.viewAuthGroups[this.route]._id!,
                    }
                    await apiManage.patch_staff_auth_group_id(params).catch((e) => { console.log(e) });
                    (this.viewAuthGroups[this.route] as any).auth_group_id = this.viewAuthGroups[this.route]._id!
                    this.sourceAuthGroups[-1] = _.cloneDeep(this.viewAuthGroups[this.route]);
                    this.resetOP()
                } else {
                    // 自定义auth配置
                    const params = {
                        _id: editAccountMobx.sourceStaffBaseInfo?._id ?? _id ?? '',
                        ...this.getUnitList('cwa').reduce((pre, now) => ({ ...pre, [now]: (this.viewAuthGroups[-1] as any)[now] }), {}),
                        ...this.getUnitList('rwa').reduce((pre, now) => ({ ...pre, [now]: (this.viewAuthGroups[-1] as any)[now] }), {}),
                        ...this.getUnitList('shell').reduce((pre, now) => ({ ...pre, [now]: (this.viewAuthGroups[-1] as any)[now] }), {}),
                    }
                    await apiManage.patch_modify_staff_auth(params);
                    this.sourceAuthGroups[-1] = _.cloneDeep(this.viewAuthGroups[-1])
                    this.resetOP()
                }
                break;
            // 新增
            case PageState.AccountAdd:
                if (this.route !== -1) {
                    // 选用auth组的配置
                    const params = {
                        staff_id: editAccountMobx.sourceStaffBaseInfo?._id ?? _id ?? '',
                        auth_group_id: this.viewAuthGroups[this.route]._id!,
                    }
                    await apiManage.patch_staff_auth_group_id(params).catch((e) => { console.log(e) });
                    (this.viewAuthGroups[this.route] as any).auth_group_id = this.viewAuthGroups[this.route]._id!
                    this.sourceAuthGroups[-1] = _.cloneDeep(this.viewAuthGroups[this.route]);
                    this.resetOP()
                } else {
                    // 自定义auth配置
                    const params = {
                        _id: editAccountMobx.sourceStaffBaseInfo?._id ?? _id ?? '',
                        ...this.getUnitList('cwa').reduce((pre, now) => ({ ...pre, [now]: (this.viewAuthGroups[-1] as any)[now] }), {}),
                        ...this.getUnitList('rwa').reduce((pre, now) => ({ ...pre, [now]: (this.viewAuthGroups[-1] as any)[now] }), {}),
                        ...this.getUnitList('shell').reduce((pre, now) => ({ ...pre, [now]: (this.viewAuthGroups[-1] as any)[now] }), {}),
                    }
                    await apiManage.patch_modify_staff_auth(params);
                    this.sourceAuthGroups[-1] = _.cloneDeep(this.viewAuthGroups[-1])
                    this.resetOP()
                }
                break;

            case PageState.AuthGroupSetting:
                // eslint-disable-next-line no-case-declarations
                const params = {
                    _id: this.viewAuthGroups[this.route]._id ?? undefined,
                    string_id: groupUnitData.belongedGroup,
                    name: this.editingName !== '' ? this.editingName : this.viewAuthGroups[this.route].name,
                    ...cwaNow,
                    ...rwaNow,
                    ...shellNow
                }
                await apiManage.patch_auth_group_id(params);
                await this.getAuthGroups(groupUnitData.belongedGroup)
                break
        }

    }


    isLoading: boolean = false;
    load() {
        this.isLoading = true;
    }
    loaded() {
        this.isLoading = false
    }
    async addBlankAuthGroup() {
        this.load()
        const params = {
            string_id: groupUnitData.belongedGroup,
            name: i18n.t('auth_group_unnamed'),
            auth_cwa_0: 0,
            auth_cwa_1: 0,
            auth_cwa_2: 0,
            auth_cwa_3: 0,
            auth_cwa_4: 0,
            auth_cwa_5: 0,
            auth_cwa_6: 0,
            auth_cwa_7: 0,
            auth_cwa_8: 0,
            auth_cwa_9: 0,
            auth_cwa_10: 0,
            auth_cwa_11: 0,
            auth_cwa_12: 0,
            auth_cwa_13: 0,
            auth_rwa_0: 0,
            auth_rwa_1: 0,
            auth_rwa_2: 0,
            auth_rwa_3: 0,
            // shell：RBP Cloud
            auth_shell_1: 0,
            // shell：菜单商店上传菜单
            auth_shell_2: 0,
        }
        const res = await apiManage.create_auth_group(params);
        if ('error' in res) {
            GlobalNotification.error(i18n.t('auth_group_add_failed'));
        } else {
            GlobalNotification.success(i18n.t('auth_group_add_suc'));
            await this.getAuthGroups(groupUnitData.belongedGroup);
            this.route = this.viewAuthGroups.length - 1;
        }
        this.loaded();
    }

    async deleteGroup() {
        const params = {
            _id: this.viewAuthGroups[this.route]._id,
            string_id: groupUnitData.belongedGroup
        }
        const res = await apiManage.delete_auth_group_id(params);
        if ('error' in res) {
            GlobalNotification.error(i18n.t('allergen_page_msg_delete_failed'));
        } else {
            GlobalNotification.success(i18n.t('allergen_page_msg_delete_succeed'));
            await this.getAuthGroups(groupUnitData.belongedGroup);
            if (this.route === this.viewAuthGroups.length) this.route--;
        }
    }

    // 复制权限
    async copyAuthGroup(): Promise<void> {
        const params = {
            _id: this.viewAuthGroups[this.route]._id,
            name: this.editingName,
            string_id: groupUnitData.belongedGroup
        }
        const res = await apiManage.copy_auth_group_by_id(params);
        if ('error' in res) {
            GlobalNotification.error(i18n.t('auth_group_copy_failed'));
        } else {
            await this.getAuthGroups(groupUnitData.belongedGroup);
        }
    }
}
type AuthGroupKey = keyof AuthGroup